module.exports = __webpack_public_path__ + "static/media/rv2g-iphone-mockup.05deea1e.png";